export default __webpack_public_path__ + "static/media/J270_21a270a.c942a84c.STEP";